import { carConsumerService } from "../../../service/car-consumer-gateway-api";

const fetchSampleReportUrl = (makeId) => () => {
    return new Promise((resolve, reject) => {
        carConsumerService.getCarServiceHistorySampleReport(makeId).then(response => {
            resolve(response);
        }).catch((e) => {
            reject(e);
        });
    });
};

export {
    fetchSampleReportUrl
};
